export function getShiftInviteCap(pattern) {
  const qty = Number(pattern?.quantity ?? 0);
  if (!Number.isFinite(qty) || qty <= 0) return 0;
  return Math.ceil(qty * 1.5);
}

function asIsoDate(value) {
  if (!value) return null;
  return String(value).slice(0, 10);
}

function uniqueIsoDates(dates) {
  if (!Array.isArray(dates)) return [];
  const out = [];
  const seen = new Set();
  for (const d of dates) {
    const iso = asIsoDate(d);
    if (!iso || seen.has(iso)) continue;
    seen.add(iso);
    out.push(iso);
  }
  return out;
}

function upsertDateCount(map, shiftIndex, isoDate, delta) {
  const shiftKey = Number(shiftIndex);
  if (!Number.isFinite(shiftKey) || !isoDate || !delta) return;
  if (!map[shiftKey]) map[shiftKey] = {};
  map[shiftKey][isoDate] = (map[shiftKey][isoDate] ?? 0) + delta;
}

export function getShiftDateCount(countsByShiftDate, shiftIndex, isoDate) {
  const shiftKey = Number(shiftIndex);
  if (!Number.isFinite(shiftKey)) return 0;
  return countsByShiftDate?.[shiftKey]?.[isoDate] ?? 0;
}

export function buildShiftDateCountsFromRequests(requests = []) {
  const out = {};
  for (const req of requests) {
    const shiftIndex = Number(req?.shiftIndex);
    if (!Number.isFinite(shiftIndex)) continue;
    const dates = uniqueIsoDates(
      Array.isArray(req?.workerShift)
        ? req.workerShift.map((x) => x?.date)
        : req?.availableDates
    );
    for (const isoDate of dates) {
      upsertDateCount(out, shiftIndex, isoDate, 1);
    }
  }
  return out;
}

export function buildShiftDateCountsFromFinalDraft(
  finalDraftByShift = {},
  excludeByShift = {}
) {
  const out = {};
  const entries = Object.entries(finalDraftByShift || {});
  for (const [rawShiftIndex, workers] of entries) {
    const shiftIndex = Number(rawShiftIndex);
    if (!Number.isFinite(shiftIndex) || !Array.isArray(workers)) continue;
    const excludedSlug = excludeByShift?.[shiftIndex] ?? null;
    for (const worker of workers) {
      if (!worker?.workerSlug) continue;
      if (excludedSlug && worker.workerSlug === excludedSlug) continue;
      const dates = uniqueIsoDates(worker.availableDates);
      for (const isoDate of dates) {
        upsertDateCount(out, shiftIndex, isoDate, 1);
      }
    }
  }
  return out;
}

export function mergeShiftDateCounts(...maps) {
  const out = {};
  for (const map of maps) {
    if (!map || typeof map !== "object") continue;
    for (const [rawShiftIndex, byDate] of Object.entries(map)) {
      const shiftIndex = Number(rawShiftIndex);
      if (!Number.isFinite(shiftIndex) || !byDate || typeof byDate !== "object") continue;
      for (const [isoDate, count] of Object.entries(byDate)) {
        upsertDateCount(out, shiftIndex, isoDate, Number(count) || 0);
      }
    }
  }
  return out;
}

export function getOverCapDatesForSelection({
  shiftIndex,
  selectedDates,
  cap,
  countsByShiftDate,
}) {
  const over = [];
  const dates = uniqueIsoDates(selectedDates);
  for (const isoDate of dates) {
    const current = getShiftDateCount(countsByShiftDate, shiftIndex, isoDate);
    if (current + 1 > cap) {
      over.push(isoDate);
    }
  }
  return over;
}
